var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.isLoggedIn == true)?_c('div',[_c('dashboard-core-app-bar'),_c('dashboard-core-drawer')],1):_vm._e(),_c('dashboard-core-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }